<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{$t("Registration")}} - {{$t("Finish")}}</h1>
          <v-progress-linear v-if="loading || wlReg.Registration == null" :indeterminate="true"></v-progress-linear>
          <div v-if="wlReg != null && wlReg.Registration != null">
            <v-flex xs12>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs2>{{$t("Article")}}:</v-flex>
                <v-flex d-flex xs5 style="padding-right: 6px">{{wlReg.Registration.ArticleNo}} - {{wlReg.Registration.ArticleName}}</v-flex>
                <v-flex d-flex xs2>{{$t("Vehicle")}}:</v-flex>
                <v-flex d-flex xs3>{{wlReg.Registration.VehicleLicensePlateNo}}</v-flex>
              </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs2>{{$t("Customer")}}:</v-flex>
                <v-flex d-flex xs5 style="padding-right: 6px">{{wlReg.Registration.CustomerNo}} - {{wlReg.Registration.CustomerName}}</v-flex>
                <v-flex d-flex xs2>{{$t("Weight")}}:</v-flex>
                <v-flex d-flex xs3>{{getWeightStr(wlReg)}}</v-flex>
              </v-layout>
              <!--v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs2>{{$t("Agreement")}}:</v-flex>
                <v-flex d-flex xs5 style="padding-right: 6px">{{wlReg.Registration.AgreementNo}} - {{wlReg.Registration.AgreementName}}</v-flex>
              </v-layout-->
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs2>{{$t("RequisitionNo1")}}:</v-flex>
                <v-flex d-flex xs5>{{wlReg.Registration.RequisitionNo1}}</v-flex>
              </v-layout>
            </v-flex>

            <v-layout xs12 style="margin-top: 10px;">
              <v-spacer></v-spacer>
              <v-btn class="mr-1 mb-1" :loading="finishing" @click="tryFinishRegistration" color="success">{{$t("Confirm")}}</v-btn>
              <v-btn class="mr-1 mb-1" color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-layout>

          </div>
        </v-flex>

        <v-dialog
          v-model="confirmDialog"
          max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("NoWeightAdded")}}</v-card-title>

            <v-card-text>
              {{$t("NoWeightAddedDescription")}}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="success"

                @click="confirmDialog = false; finishRegistration();">
                {{$t("NoWeightAnswerYes")}}
              </v-btn>

              <v-btn
                color="primary"

                @click="confirmDialog = false">
                {{$t("NoWeightAnswerNo")}}
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as WheelLoader from '@/modules/wheel-loader/wheel-loader'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'wheel-loader-registration',
    loading: true,
    finishing: false,
    valid: true,
    confirmDialog: false,
    redirectTo: 'wheel-loader-registrations',
    form: {
      facilityNo: '',
      vehicleLicensePlateNo: '',
      articleNo: '',
      articleName: '',
      customerNo: '',
      customerName: '',
      vehicleNo: '',
      vehicleName: '',
      agreementNo: '',
      agreementName: '',
      requisitionNo1: ''
    },
    wlReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      finishedDate: null,
      finishedBy: null,
      comment: null,
      Registration: null
    }

  }),
  computed: {},
  methods: {
    async tryFinishRegistration () {
      if (this.wlReg.Registration.WeightNet > 0 || this.wlReg.Registration.WeightFirst > 0) {
        // If weight exist, then finish immediately.
        this.finishRegistration()
      } else {
        // Ask user if is OK to finish.
        // Show the dialog. The rest is handled in click events of the dialog.
        this.confirmDialog = true
      }
    },
    getWeightStr (wlReg) {
      // wlReg.Registration.WeightNet || 0
      if (wlReg && wlReg.CreatedBy.startsWith('corp:')) {
        // Weighing is via weightbridge
        if (wlReg.Registration.Completed) {
          return wlReg.Registration.WeightNet + ' kg'
        } else {
          return wlReg.Registration.WeightFirst + ' kg (' + this.$t('WeightFirst') + ')' // Vehicle has only done a first weighing
        }
      } else {
        // Weighing is via wheelloader
        return Math.abs(wlReg.Registration.WeightFirst - wlReg.Registration.WeightSecond) + ' kg'
      }
    },
    async finishRegistration () {
      this.confirmDialog = false
      this.preventLeave = false
      this.finishing = true
      const res = await WheelLoader.saveRegistration({
        Id: this.wlReg.id,
        RegistrationId: this.wlReg.registrationId,
        Facility: this.form.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.wlReg.finishedBy,
        Comment: this.wlReg.comment,
        Registration: this.wlReg.Registration
      })
      this.finishing = false
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        this.$router.push({ name: this.redirectTo })
      }
    }
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    if (this.$route.params.id) {
      this.wlReg.id = this.$route.params.id
      const res = await WheelLoader.loadRegistration(this.wlReg.id)
      if (!res.failed) {
        this.form.facilityNo = res.data.Facility
        this.form.vehicleLicensePlateNo = res.data.VehicleLicensePlateNo
        this.form.vehicleNo = res.data.Registration.VehicleNo
        this.form.vehicleName = res.data.Registration.VehicleName
        this.form.agreementNo = res.data.Registration.AgreementNo
        this.form.agreementName = res.data.Registration.AgreementName
        this.form.customerNo = res.data.Registration.CustomerNo
        this.form.customerName = res.data.Registration.CustomerName
        this.form.articleNo = res.data.Registration.ArticleNo
        this.form.articleName = res.data.Registration.ArticleName
        this.form.requisitionNo1 = res.data.Registration.RequisitionNo1

        this.wlReg.registrationId = res.data.RegistrationId
        this.wlReg.finishedDate = res.data.FinishedDate
        this.wlReg.finishedBy = res.data.FinishedBy
        this.wlReg.CreatedBy = res.data.CreatedBy
        this.wlReg.comment = res.data.Comment
        this.wlReg.Registration = res.data.Registration
      }
    } else {
      // ERROR
      // Calling this view incorrectly.
      this.$root.$message.showError(this.$t('Invalid registration id'))
    }
    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
